import { render } from "./Templates.vue?vue&type=template&id=4c074f62"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/Templates.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c074f62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c074f62', __exports__)) {
    api.reload('4c074f62', __exports__)
  }
  
  module.hot.accept("./Templates.vue?vue&type=template&id=4c074f62", () => {
    api.rerender('4c074f62', render)
  })

}


export default __exports__